<template>
    <div class="widget">
        <PDFViewer
            v-if="url && active"
            :url="url"
        />
    </div>
</template>

<script>
    import Http from '@/api/data';
    import { EventBus } from "@/event-bus";
    import { mapActions, mapGetters } from 'vuex';

    import PDFViewer from '@/components/pdfViewer/PDFViewer.vue';

    export default {
        name: 'DocumentationWidget',
        components: {
            PDFViewer
        },
        props: [
            'data',
            'standalone',
            'link',
            'active',
            'standalone'
        ],
        data() {
            return {
                url: null
            };
        },
        computed: {
            ...mapGetters([
                'isReviewUse',
                'language',
                'protocol'
            ]),
            apiUrl() {
                return 'https://' + (this.isReviewUse ? process.env.API_LIST.REVIEW : process.env.API_LIST.FO);
            }
        },
        mounted() {
            this.render();
            EventBus.$on('updateDocumentSource', url => this.updateDocument(url));
        },
        methods: {
            ...mapActions(['setIsLoading']),
            render() {
                let urlLink = this.$props.link ? this.$props.link : this.apiUrl + '/request-data/documentation' + window.location.search;
                if (this.language && !urlLink.includes('&language'))
                    urlLink += '&language=' + this.language;
                Http.getData(urlLink).then(payload => {
                    if (payload) {
                        payload.type = 'documentation';
                        payload.widgetType = 'documentation';
                        payload.widgetTitle = 'documentation';
                        payload = Object.assign(payload, { widgetTitle: payload.widgetTitle });
                        let activeDocument = null;
                        if (payload.documents) {
                            activeDocument = payload.documents.filter((document) => document.active === true)[0];
                            this.setIsLoading(false);
                        }

                        if (payload.language)
                            this.$i18n.locale = payload.language;

                        payload.source = activeDocument && activeDocument.link ? activeDocument.link : null;
                        this.url = payload.source;

                        if (this.standalone)
                            EventBus.$emit('setSidebarData', payload);
                        else
                            EventBus.$emit('updateSidebar', payload, false);

                        if (this.$vuetify.breakpoint.smAndDown)
                            EventBus.$emit('closeSidebar');
                        EventBus.$emit('trackWidget', payload.tracking);
                    }
                }).catch(error => {
                    EventBus.$emit('setErrorState', true, error);
                });
            },
            updateDocument(url) {
                this.url = url;
            }
        },
        watch: {
            active() {
                if (this.active)
                    this.render();
            }
        }
    }
</script>

<style lang="scss">
    .content-widget{
        iframe{
            position: absolute;
            top: 0;
            left: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/DocumentationWidget.vue